import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

import { getArchiveSuccess } from "@/store/Crud/functions/archived/getters";

export function getVehicleUsageRequirementsByLicenseClass(state: State): any {
  return state.vehicleUsageRequirementsByLicenseClass;
}

export function getVehiclesByInstructorAndUsageAndLicenseClass(state: State): any {
  return state.vehiclesByInstructorAndUsageAndLicenseClass;
}

export function getVehiclesByCurrentInstructor(state: State): any {
  return state.vehiclesByCurrentInstructor;
}

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getArchiveSuccess,
  getVehicleUsageRequirementsByLicenseClass,
  getVehiclesByInstructorAndUsageAndLicenseClass,
  getVehiclesByCurrentInstructor,
};
